/*
 * @Author: zhu.huijun
 * @Date: 2021-05-08 14:41:18
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-06-25 16:25:49
 */
import { qrySubsListBsnl } from '@/services/subsSelection';
import { getRequestData } from '@/utils';

export default {
  namespace: 'subsSelection',
  state: {},
  effects: {
    *qrySubsList({ payload }, { call }) {
      const response = yield call(qrySubsListBsnl, payload);
      return getRequestData(response);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
